export default __webpack_public_path__ + "static/media/test.30621b5b.png";